const RECENT_TAGS_KEY = 'checkmate_recent_tag_ids';
const MAX_RECENT = 3;

export const getRecentTagIds = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(RECENT_TAGS_KEY)) || [];
    if (!Array.isArray(raw)) return [];
    return raw
      .map(id => Number(id))
      .filter(n => !Number.isNaN(n) && n > 0)
      .slice(0, MAX_RECENT);
  } catch {
    return [];
  }
};

export const saveRecentTagId = tagId => {
  const numId = Number(tagId);
  if (Number.isNaN(numId) || numId <= 0) return;
  const prev = getRecentTagIds().filter(id => Number(id) !== numId);
  localStorage.setItem(RECENT_TAGS_KEY, JSON.stringify([numId, ...prev].slice(0, MAX_RECENT)));
};
